import Employees from './views/Employees.vue'
import HomeLayout from '@/layouts/Home.vue'

export const employeesConfigRoutes = [
  {
    path: '/employees',
    name: 'employees',
    component: Employees,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
]
